const keysHaveDefaultValueConstant = ['viewPermission'];

export const handleCheckChangeForm = (obj: any, defaultData: any): boolean => {
  // return false if something change, vice versa
  for (const key in obj) {
    // use JSON to check array and object also
    if (JSON.stringify(obj[key]) !== JSON.stringify(defaultData[key])) return false;
  }
  return true;
};

export const handleCheckFalsyForm = (obj: any, keysHaveDefaultValue: string[] = keysHaveDefaultValueConstant): boolean => {
  // return false if some value is not falsy, vice versa
  for (const key in obj) {
    if (
      obj[key] &&
      !keysHaveDefaultValue.some((eachKey: string) => eachKey === key)
    )
      return false;
  }
  return true;
};
